import ResourceStore from "../../shared/services/ResourceStore";

class CountryStore extends ResourceStore {
  _baseUrl (_params) {
    return "/api/v4";
  }
}

export default new CountryStore("country");
